export function getValue (name) {
  return localStorage.getItem(`form-value-${name}`)
}

export function setValue (name, value) {
  localStorage.setItem(`form-value-${name}`, value)
}
